import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  public user: any;
  @Input() public opened = true;
  @Output() public openedChange = new EventEmitter<boolean>();

  constructor(private auth: AuthService, private router: Router) {}

  ngOnInit() {
    this.auth.getUser().subscribe(user => (this.user = user));
  }

  public toggle() {
    this.openedChange.emit(!this.opened);
  }

  public logout() {
    this.auth.logout().then(() => {
      this.router.navigate(['/login']);
    });
  }
}
